import { useParams } from 'react-router-dom'

import EditMedicalLeave from 'modules/timeoff/components/EditMedicalLeave'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const EditMedicalLeavePage = () => {
  const { leave_id: leaveId } = useParams()
  const onClose = useOnClose()

  if (!leaveId) {
    return null
  }

  return <EditMedicalLeave leaveId={parseInt(leaveId, 10)} onClose={onClose} />
}

export default EditMedicalLeavePage
